export const FETCH_FACEBOOK_FORMS_FIELDS = "FETCH_FACEBOOK_FORMS_FIELDS";
export const FETCH_FACEBOOK_FORMS_FIELDS_SUCCESS = "FETCH_FACEBOOK_FORMS_FIELDS_SUCCESS";
export const FETCH_FACEBOOK_FORMS_FIELDS_FAILED = "FETCH_FACEBOOK_FORMS_FIELDS_FAILED";

export const UPDATE_FACEBOOK_FORMS_FIELDS = "UPDATE_FACEBOOK_FORMS_FIELDS";
export const UPDATE_FACEBOOK_FORMS_FIELDS_SUCCESS = "UPDATE_FACEBOOK_FORMS_FIELDS_SUCCESS";
export const UPDATE_FACEBOOK_FORMS_FIELDS_FAILED = "UPDATE_FACEBOOK_FORMS_FIELDS_FAILED";